/* eslint-disable no-useless-escape */
import * as yup from 'yup';

const URL_REGEXP = /^(((https?|ftp):)?\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i

export const contactsFormSchema = yup.object().shape({
  website: yup.string().matches(URL_REGEXP, 'Website must be a valid URL').required('Please enter website url'),
  company: yup.string().required('Please enter company/your name'),
  address: yup.string().required('Please enter address'),
  email: yup.string().email('Email is not valid').required('Please enter an email'),
  phone: yup.string(),
})

export const informationFormSchema = yup.object().shape({
  collectInfo: yup.array().ensure()
    .of(
      yup.object().shape({
        value: yup.boolean(),
        retentionPeriod: yup.string().when(['value', 'isCustom'], {
          is: (value, isCustom) => value === true || isCustom === true,
          then: yup.string().required('Retention period is required'),
          otherwise: yup.string().notRequired(),
        }),
        legalBasis: yup.string().when(['value', 'isCustom'], {
          is: (value, isCustom) => value === true || isCustom === true,
          then: yup.string().required('Legal basis is required'),
          otherwise: yup.string().notRequired(),
        }),
        whatWeCollect: yup.string().when('isCustom', {
          is: true,
          then: yup.string().required('This field is required'),
          otherwise: yup.string().notRequired(),
        }),
        purpose: yup.string().when('isCustom', {
          is: true,
          then: yup.string().required('This field is required'),
          otherwise: yup.string().notRequired(),
        }),
        subcategories: yup.array().ensure().when(['value', 'isCustomSubcategories'], {
          is: (value, isCustomSubcategories) => value === true && isCustomSubcategories === true,
          then: yup.array().test(
            'at-least-one-checked',
            'At least one should be checked',
            function (value) {
              if (!this.parent.value) return true;
              if (this.parent.isCustom) return true;

              const { customSubcategories } = this.parent;
              const hasCheckedSubcategory = value.some(sub => sub.value);
              const hasCustomSubcategories = customSubcategories && customSubcategories.length > 0;
              return hasCheckedSubcategory || hasCustomSubcategories;
            }
          ),
          otherwise: yup.array().notRequired(),
        }),
        customSubcategories: yup.array().ensure().of(
          yup.object().shape({
            label: yup.string().required('Subcategory name is required'),
          })
        )
      })
    )
    .test(
      'at-least-one-main-checked',
      'At least one should be checked',
      (arr) => Array.isArray(arr) && arr.some(item => item.value || item.isCustom)
    ),
  wayCollect: yup.array().ensure().test(
    'at-least-one-checked',
    'At least one should be checked',
    (arr) => Array.isArray(arr) && arr.some(item => item.value)
  ),
  legitimateSources: yup.boolean(),
  legitimateSourcesCategories: yup.array().ensure().when('legitimateSources', {
    is: true,
    then: yup.array()
      .test(
        'at-least-one-checked',
        'At least one should be checked',
        (arr) => Array.isArray(arr) && arr.some(item => item.value)
      )
      .required('At least one should be checked'),
    otherwise: yup.array().notRequired(),
  }),
  publicSources: yup.boolean(),
  publicSourceValue: yup.string().when('publicSources', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
  requiredByLaw: yup.boolean(),
  requiredByLawValue: yup.string().when('requiredByLaw', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
  requiredByContract: yup.boolean(),
  requiredByContractValue: yup.string().when('requiredByContract', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
});


export const usageFormSchema = yup.object().shape({
  shareCollectInfo: yup.array(),
  isPersonalDataTransferedToThirdCountry: yup.boolean(),
  thirdPartyCountries: yup.array().when('isPersonalDataTransferedToThirdCountry', {
    is: true,
    then: yup.array().min(1, 'At least one country must be selected').required('At least one country must be selected'),
    otherwise: yup.array().notRequired(),
  }),
  thirdPartyLegalBasis: yup.string().when('isPersonalDataTransferedToThirdCountry', {
    is: true,
    then: yup.string().required('Legal basis is required'),
    otherwise: yup.string().notRequired(),
  }),
  thirdPartyCustomLegalBasis: yup.string().when(['isPersonalDataTransferedToThirdCountry', 'thirdPartyLegalBasis'], {
    is: (isPersonalDataTransferedToThirdCountry, thirdPartyLegalBasis) => 
      isPersonalDataTransferedToThirdCountry === true && thirdPartyLegalBasis === 'Other',
    then: yup.string().required('Custom legal basis is required'),
    otherwise: yup.string().notRequired(),
  }),
})

export const extrasFormSchema = yup.object().shape({
  isDecisionMaking: yup.boolean().default(false),
  decisionMakingPurpose: yup.string().when('isDecisionMaking', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
  decisionMakingHowWorks: yup.string().when('isDecisionMaking', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
  decisionMakingHowAffects: yup.string().when('isDecisionMaking', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
  supervisoryAuthorityCountry: yup.mixed().nullable().required('This field is required'),
  supervisoryAuthorityCountryEUandEEA: yup.boolean().default(false),
  supervisoryAuthorityName: yup.string().when('supervisoryAuthorityCountryEUandEEA', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
  supervisoryAuthorityLink: yup.string().when('supervisoryAuthorityCountryEUandEEA', {
    is: true,
    then: yup.string().required('This field is required'),
    otherwise: yup.string().notRequired(),
  }),
  privacyOfficer: yup.object().required('At least one should be checked'),  
  officerName: yup.string().when('privacyOfficer', (privacyOfficer, schema) => {
    if(privacyOfficer) {
      return privacyOfficer.id !== 'noPerson' ? schema.required('Please enter officer name') : schema
    } else {
      return schema
    }
  }),
  officerEmail: yup.string().email('Email is not valid').when('privacyOfficer', (privacyOfficer, schema) => {
    if(privacyOfficer) {
      return privacyOfficer.id !== 'noPerson' ? schema.required('Please enter officer email') : schema
    } else {
      return schema
    }
  }),
  officerPhone: yup.string(),
  effectiveDate: yup.string().nullable().required('Please enter an effective date'),
})